import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoggingService } from '@core/services/logging.service';
import { catchError, throwError } from 'rxjs';

/**
 * Interceptor para registrar erros HTTP críticos (5xx ou falhas de rede).
 */
export const loggingInterceptor: HttpInterceptorFn = (req, next) => {
	const logger = inject(LoggingService);

	return next(req).pipe(
		catchError((error: unknown) => {
			if (error instanceof HttpErrorResponse) {
				const critical = error.status >= 500 || error.status === 0;

				if (critical) {
					logger.logError(error, {
						tags: {
							source: 'http-interceptor',
							method: req.method,
							url: req.url,
						},
						extras: {
							status: error.status,
							statusText: error.statusText,
							message: error.message,
							endpoint: req.url,
							body: error.error,
						},
					});
				}
			} else {
				logger.logError(error, { tags: { source: 'http-interceptor-unknown' } });
			}

			return throwError(() => error);
		})
	);
};
